import type { SkeletonVariant } from '../components/skeletons';

const PUBLIC_PREFIXES = [
  '/',
  '/about',
  '/contact',
  '/course',
  '/programs',
  '/placement',
  '/privacy',
  '/termsofservice',
  '/job-applications',
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/set-password',
  '/auth/google-followup',
];

function isPathMatch(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function getShellVariantFromPath(pathname: string): SkeletonVariant {
  if (!pathname) return 'generic';

  if (pathname.startsWith('/reception')) return 'reception';
  if (pathname.startsWith('/student') || pathname.startsWith('/languages/student')) return 'student';
  if (pathname.startsWith('/sales')) return 'sales';
  if (pathname.startsWith('/manager')) return 'manager';
  if (pathname.startsWith('/hr')) return 'hr';
  if (pathname.startsWith('/accountant')) return 'accountant';
  if (pathname.startsWith('/marketing')) return 'marketing';
  if (pathname.startsWith('/employee')) return 'employee';

  if (PUBLIC_PREFIXES.some((prefix) => isPathMatch(pathname, prefix))) {
    return 'public';
  }

  return 'generic';
}
